import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import axios from "axios";
import ApiList from "../utils/api_list";
import AwsAxios from "../utils/AwsAxios";
import {
  getBasicInfo,
  getUserMessageById,
  getCalendarDetails,
  getUserFormsDetails,
  profileCompletion,
  BugReports,
  getStreak,
  getUserUnreadMessagesCount,
} from "../services/awsServices";
import toastMessage from "../utils/toastMessage";

const initialState = {
  userAttributes: JSON.parse(localStorage?.getItem("userAttributes") ?? "{}"),
  channelList: [],
  messagesObj: {},
  msgLoading: false,
  newMsgDetailObj: {},
  connectedUser: [],
  selectedUserOrChannel: {},
  channelCreateLoader: false,
  addUserInChannel: { loader: false, isAdded: false },
  isChannelCreated: false,
  userChannelList: [],
  usersInChannel: {},
  userBasicInfo: [],
  calenderDetails: [],
  activeTabForPersonalInfo: "1",
  userAllFormsDetails: [],
  profileCompletion: [],
  streakData: [],
  liveNotificationBySme: {},
  userList: [],
  smeList: [],
  partnerList: [],
  adminList: [],
};

export const getUserListThunk = createAsyncThunk(
  "user/getUserListThunk",
  async (data, thunkAPI) => {
    try {
      const url = ApiList.utils + "/user";
      let response = await AwsAxios.get(url);
      console.log(response.data, "getUserListThunk");
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const finalSubmission = createAsyncThunk(
  "user/finalSubmission",
  async (data, thunkAPI) => {
    try {
      const url = ApiList.profile + "/talent/final-submission";
      let response = await AwsAxios.patch(url);
      console.log(response.data, "getUserListThunk");
      if (response) {
        toastMessage(response?.data?.message, "success");
      }
      return response.data;
    } catch (err) {
      console.log("🚀 ~ err:", err);
      if (err) {
        toastMessage(err?.response?.data?.message, "error");
      }
      return thunkAPI.rejectWithValue(err);
    }
  }
);

// Remove above if not use
export const getUserSmePartnerAdminListThunk = createAsyncThunk(
  "user/getUserSmePartnerAdminListThunk",
  async (data, thunkAPI) => {
    try {
      const url = `${ApiList.profile}/talent-sme-partner-admin-list`;
      let response = await AwsAxios.get(url);
      console.log(response.data, "getUserSmePartnerAdminListThunk");
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const updateUserPrivateMsgStatusThunk = createAsyncThunk(
  "user/updateUserPrivateMsgStatusThunk",
  async ({ userId }, thunkAPI) => {
    try {
      if (!userId) return;
      const url = `${ApiList.utils}/user/message/${encodeURIComponent(userId)}`;
      console.log(
        url,
        "===url:updateUserPrivateMsgStatusThunkupdateUserPrivateMsgStatusThunk"
      );

      const resp = await AwsAxios.patch(url);
      console.log(resp, " =resp: updateUserPrivateMsgStatusThunk:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getConnectedUserListThunk = createAsyncThunk(
  "user/getConnectedUserListThunk",
  async (_, thunkAPI) => {
    try {
      const url = ApiList.utils + "/user/connected";
      let response = await AwsAxios.get(url);
      console.log(response.data, "getConnectedUserListThunk");
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getChannelListThunk = createAsyncThunk(
  "user/getChannelListThunk",
  async (_, thunkAPI) => {
    try {
      const url = ApiList.utils + "/channels";
      let response = await AwsAxios.get(url);
      // console.log(response.data, "getConnectedUserListThunk");
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getUserInChannelByChannelIdThunk = createAsyncThunk(
  "user/getUserInChannelByChannelIdThunk",
  async (id, thunkAPI) => {
    try {
      console.log(id, " = idddddddddddddddddddddddddddddddddddddddd");
      const curChannelId = id?.split("Channel#")[1];
      const url = ApiList.utils + "/channels/user/" + curChannelId;
      let response = await AwsAxios.get(url);
      // console.log(response.data, "getConnectedUserListThunk");
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getMessagesOfChannelByChannelIdThunk = createAsyncThunk(
  "user/getMessagesOfChannelByChannelIdThunk",
  async (id, thunkAPI) => {
    try {
      console.log(id, " = iddd:getMessagesOfChannelByChannelIdThunk");
      const curChannelId = id?.split("Channel#")[1];
      const url = ApiList.utils + "/channels/messages/" + curChannelId;
      let response = await AwsAxios.get(url);
      // console.log(response.data, "getConnectedUserListThunk");
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const BugReportsSlice = createAsyncThunk(
  "user/BugReportsSlice",
  async (data, thunkAPI) => {
    try {
      const resp = await BugReports(data);
      return resp.data;
      // console.log(response.data, "getConnectedUserListThunk");
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getUserBasicInfo = createAsyncThunk(
  "user/getUserBasicInfo",
  async (data, thunkAPI) => {
    try {
      const resp = await getBasicInfo(data);
      console.log(resp, " =resp: getCourseraContents:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getStreakData = createAsyncThunk(
  "user/getStreakData",
  async (data, thunkAPI) => {
    try {
      const resp = await getStreak();
      console.log(resp, " =resp: getCourseraContents:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getUserCalendarDetails = createAsyncThunk(
  "user/getUserCalendarDetails",
  async (data, thunkAPI) => {
    try {
      const resp = await getCalendarDetails();
      console.log(resp, " =resp: getCourseraContents:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getUserMessageByIdthunk = createAsyncThunk(
  "user/getUserMessageByIdthunk",
  async (userId, thunkAPI) => {
    try {
      // const id = userId.includes("User#") ? userId.split("User#")[1] : userId;
      const resp = await getUserMessageById(encodeURIComponent(userId));
      console.log(resp, " =resp: getUserMessageByIdthunk:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getUserUnreadMsgCounThunk = createAsyncThunk(
  "user/getUserUnreadMsgCounThunk",
  async (_, thunkAPI) => {
    try {
      const resp = await getUserUnreadMessagesCount();
      console.log(resp, " =resp: getUserUnreadMsgCounThunk:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getUserAllFormsDetails = createAsyncThunk(
  "user/getUserAllFormsDetails",
  async (userId, thunkAPI) => {
    try {
      // const id = userId.includes("User#") ? userId.split("User#")[1] : userId;
      const resp = await getUserFormsDetails();
      console.log(resp, " =resp: getUserAllFormsDetails:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = getUserAllFormsDetails:codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const profileCompletionSlice = createAsyncThunk(
  "user/profile-completion",
  async (userId, thunkAPI) => {
    try {
      // const id = userId.includes("User#") ? userId.split("User#")[1] : userId;
      const resp = await profileCompletion();
      console.log(resp, " =resp: getUserAllFormsDetails:slice");
      return resp.data;
    } catch (err) {
      console.log(err, " = getUserAllFormsDetails:codeResssssssssssss:err");
      return thunkAPI.rejectWithValue(err);
    }
  }
);

const userSlice = createSlice({
  initialState,
  name: "user",
  reducers: {
    setMessageReducer: (state, action) => {
      // const userId = action.payload.userId;
      // state.messagesObj[userId] = action.payload.messages;
      const newMsg = action.payload.newMsg;
      state.liveNotificationBySme = newMsg;
      const isSend = action.payload.isSend || false;
      console.log(
        newMsg,
        " ==========newMssssgggggggggggggggggggggggggg",
        isSend,
        "= issend"
      );
      // let key = newMsg?.senderId;
      let key, messages;
      const { messagesObj, newMsgDetailObj } = current(state);
      const newMsgDetObj = { ...newMsgDetailObj };

      if (isSend && newMsg?.PK?.includes("Channel#")) {
        key = newMsg?.PK;
        // newMsgDetObj[key] = (newMsgDetObj[key] || 0) + 1;
        messages =
          messagesObj[key] && messagesObj[key]?.length
            ? [...messagesObj[key], newMsg]
            : [newMsg];
      } else if (isSend) {
        key = newMsg?.Receiver;
        messages =
          messagesObj[key] && messagesObj[key]?.length
            ? [...messagesObj[key], newMsg]
            : [newMsg];
      } else if (!isSend && newMsg?.PK?.includes("Channel#")) {
        key = newMsg?.PK;
        newMsgDetObj[key] = (newMsgDetObj[key] || 0) + 1;
        messages =
          messagesObj[key] && messagesObj[key]?.length
            ? [...messagesObj[key], newMsg]
            : [newMsg];
      } else if (!isSend) {
        key = newMsg?.Sender;
        newMsgDetObj[key] = (newMsgDetObj[key] || 0) + 1;
        messages =
          messagesObj[key] && messagesObj[key]?.length
            ? [...messagesObj[key], newMsg]
            : [newMsg];
      }
      state.messagesObj = { ...messagesObj, [key]: messages };
      state.newMsgDetailObj = newMsgDetObj;
    },
    setMessageDetailsReducer: (state, action) => {
      const { userId, isRemove } = action.payload;
      // state.newMsgDetailObj = action.payload.messageCounts;
      const { newMsgDetailObj } = current(state);
      const msgDelObj = { ...newMsgDetailObj };
      if (msgDelObj[userId] && isRemove) {
        delete msgDelObj[userId];
      }
      state.newMsgDetailObj = msgDelObj;
    },
    setuserAttributesReducer: (state, action) => {
      state.userAttributes = action.payload;
    },
    setConnectedUserListReducer: (state, action) => {
      const { connectedUser } = current(state);
      const newConn = [...connectedUser, ...action.payload];
      state.connectedUser = Array.from(new Set(newConn));
    },
    setChannelCreateLoader: (state, action) => {
      state.channelCreateLoader = action.payload.load || false;
      state.isChannelCreated = action.payload.isChannelCreated || false;
    },
    setAddUserInChannel: (state, action) => {
      const { channelId, userIds, loader, isAdded } = action.payload || {};
      state.addUserInChannel = { loader, isAdded };
      // if(isAdded){
      //   const { usersInChannel, userList } = current(state);
      //   console.log(usersInChannel, " ==AllUsersInChannel:userSlice");
      //   console.log(usersInChannel[channelId], " ==usersInChannel:userSlice, ", channelId);
      //   console.log(userList, "==usersInChannel:userSlice:userList");

      //   const updatedUsersInChannel = { ...usersInChannel }
      //   const channelNew = { ...usersInChannel[channelId] };
      //   for (let i = 0; i < userList.length; i++) {
      //     const user = userList[i];
      //     if(userIds.includes(user?.PK?.S)){
      //       channelNew[user?.PK?.S] = user;
      //     }
      //   }
      //   updatedUsersInChannel[channelId] = channelNew;
      //   state.usersInChannel = updatedUsersInChannel;
      // }
    },
    setSelectedUserOrChannel: (state, action) => {
      state.selectedUserOrChannel = action.payload;
    },
    setMsgLoading: (state, action) => {
      state.msgLoading = action.payload;
    },
    setTabsForPersonalInfo: (state, action) => {
      console.log(action.payload, "payloaddd active tab");
      state.activeTabForPersonalInfo = action.payload;
    },
    setNewChannelList: (state, action) => {
      state.userChannelList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserListThunk.fulfilled, (state, action) => {
      console.log(action.payload, "getUserListThunk.fulfilled: action.payload");
      console.log(action.payload);
      state.userList = action.payload;
    });
    builder.addCase(
      getUserSmePartnerAdminListThunk.fulfilled,
      (state, action) => {
        console.log(
          action.payload,
          "getUserListThunk.fulfilled: action.payload"
        );
        state.userList = action.payload.data.UserList;
        state.smeList = action.payload.data.SMEList;
        state.partnerList = action.payload.data.PartnerList;
        state.adminList = action.payload.data.AdminList;
      }
    );
    builder.addCase(getUserCalendarDetails.fulfilled, (state, action) => {
      console.log(action.payload, "getUserListThunk.fulfilled: action.payload");
      state.calenderDetails = action.payload;
    });
    builder.addCase(getStreakData.fulfilled, (state, action) => {
      state.streakData = action.payload;
    });
    builder.addCase(getChannelListThunk.fulfilled, (state, action) => {
      console.log(
        action.payload,
        "getChannelListThunk.fulfilled: action.payload"
      );
      state.userChannelList = action.payload;
    });
    builder.addCase(getUserAllFormsDetails.fulfilled, (state, action) => {
      console.log(
        action.payload,
        "getChannelListThunk.fulfilled: action.payload"
      );
      state.userAllFormsDetails = action.payload.data;
    });
    builder.addCase(getUserBasicInfo.fulfilled, (state, action) => {
      console.log(action.payload, "getUserListThunk.fulfilled: action.payload");
      state.userBasicInfo = action.payload;
    });
    builder.addCase(
      getUserInChannelByChannelIdThunk.fulfilled,
      (state, action) => {
        // console.log(action.meta.arg, "getUserInChannelByChannelIdThunk.fulfilled: id");
        console.log(
          action.payload,
          "getUserInChannelByChannelIdThunk.fulfilled: action.payload"
        );
        const channelId = action.meta.arg;
        const { usersInChannel } = current(state);
        const updateUserInChannel = { ...usersInChannel };
        const _usersInChannel = {};
        for (let i = 0; i < action.payload?.length; i++) {
          const user = action.payload[i];
          _usersInChannel[user.PK] = user;
        }
        updateUserInChannel[channelId] = _usersInChannel;
        state.usersInChannel = updateUserInChannel;
      }
    );
    builder.addCase(
      getMessagesOfChannelByChannelIdThunk.fulfilled,
      (state, action) => {
        // console.log(action.meta.arg, "getUserInChannelByChannelIdThunk.fulfilled: id");
        console.log(
          action.payload,
          "getMessagesOfChannelByChannelIdThunk.fulfilled: action.payload"
        );
        const { messagesInChannel, channelId } = action.payload;
        const { messagesObj } = current(state);
        state.messagesObj = { ...messagesObj, [channelId]: messagesInChannel };
      }
    );
    builder.addCase(getUserMessageByIdthunk.fulfilled, (state, action) => {
      const { messagesObj } = current(state);
      const userId = action.meta.arg;
      state.messagesObj = { ...messagesObj, [userId]: action.payload };
    });
    builder.addCase(profileCompletionSlice.fulfilled, (state, action) => {
      const profileData = action.payload.data;
      console.log({ profileData });
      state.profileCompletion = profileData;
    });
    builder.addCase(getUserUnreadMsgCounThunk.fulfilled, (state, action) => {
      console.log(
        action.payload,
        "getUserUnreadMsgCounThunk.fulfilled: action.payload"
      );
      state.newMsgDetailObj = action.payload.data;
    });
  },
});

export const {
  setMessageReducer,
  setMessageDetailsReducer,
  setuserAttributesReducer,
  setConnectedUserListReducer,
  setChannelCreateLoader,
  setAddUserInChannel,
  setSelectedUserOrChannel,
  setMsgLoading,
  setTabsForPersonalInfo,
  setNewChannelList,
} = userSlice.actions;
export default userSlice.reducer;
